import { Dayjs } from "dayjs";

export const ACTIVITY_PERIOD_WEEK_OPTIONS = [4, 12, 26] as const;
export type ActivityPeriodWeeks = (typeof ACTIVITY_PERIOD_WEEK_OPTIONS)[number];
export const DEFAULT_ACTIVITY_PERIOD_WEEKS: ActivityPeriodWeeks = 4;

export type ActivityPeriod = {
  weekStarts: Dayjs[];
  from: Dayjs;
  to: Dayjs;
};

export function startOfMondayWeek(day: Dayjs): Dayjs {
  const daysSinceMonday = (day.day() + 6) % 7;
  return day.startOf("day").subtract(daysSinceMonday, "day");
}

export function startOfSundayWeek(day: Dayjs): Dayjs {
  const daysSinceSunday = day.day();
  return day.startOf("day").subtract(daysSinceSunday, "day");
}

export function lastCompleteWeeks(weeks: number, now: Dayjs): ActivityPeriod {
  const currentWeekStart = startOfSundayWeek(now);
  const weekStarts = Array.from({ length: weeks }, (_, weekIndex) =>
    currentWeekStart.subtract(weeks - weekIndex, "week"),
  );
  return {
    weekStarts,
    from: weekStarts[0],
    to: currentWeekStart.subtract(1, "millisecond"),
  };
}

export function isWithinPeriod(day: Dayjs, period: ActivityPeriod): boolean {
  return !day.isBefore(period.from) && !day.isAfter(period.to);
}
